import request from '@/config/axios'

// 用户密码重置
// skipErrorNotify：「用户密码校验失败」等业务错误不弹全局通知卡片，由 ResetPwd.vue 轻提示
export const updateUserPassword = (oldPassword: string, newPassword: string) => {
  return request.put({
    url: '/system/user/profile/update-password',
    skipErrorNotify: true,
    data: {
      oldPassword: oldPassword,
      newPassword: newPassword
    }
  })
}

// 竞价平台修改个人信息：只改传了的字段（后端按 null 跳过，注意空串会被真的写入）
// 手机号、邮箱跨竞价机构不可重复；改密码须同时传 oldPassword + newPassword，且改完要重新登录
export interface BiddingProfileUpdateReqVO {
  nickname?: string
  mobile?: string
  email?: string
  oldPassword?: string
  newPassword?: string
}

export const updateBiddingProfile = (data: BiddingProfileUpdateReqVO) => {
  return request.put<boolean>({ url: '/system/bidding/update-profile', data })
}
